import { checkIsTypeScriptProject } from "./checkIsTypeScriptProject.js";
const getJSFileExtension = async ({ helpers, options, jsx = false }) => {
  const isTypeScriptProject = await checkIsTypeScriptProject({
    helpers,
    options
  });
  if (isTypeScriptProject) {
    return jsx ? "tsx" : "ts";
  } else {
    return jsx && options.jsxExtension ? "jsx" : "js";
  }
};
export {
  getJSFileExtension
};
//# sourceMappingURL=getJSFileExtension.js.map
